// store/authStore.js
import { create } from "zustand";
import { getBannerData } from "../api/home";
import { getEmergencyData } from "../api/emergency";

export const useEmergencyStore = create((set, get) => ({
    loading: true,
    banner: null,
    emergency: [],

    getBanner: async () => {
        try {
            set({ loading: true })
            const res = await getBannerData('emergency')
            set({ loading: false, banner: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getEmergency: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await getEmergencyData(pageNumber, pageSize, search, field)
            set({ loading: false, emergency: res?.ref })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    }

}));
